module.exports = __webpack_public_path__ + "static/media/replit.2e7309e6.png";